import { io, Socket } from "socket.io-client";
import { Service } from "utils/services";

interface ServerToClientEvents {
  onFlipFlopComment: (data: string) => void;
  viewerCountUpdate: (count: number) => void;
  OnFlipFlopStreamEnded: (data: any) => void;
  OnFlipFlopStreamStarted: (data: any) => void;
  connect: () => void;
  disconnect: () => void;
  error: (message: string) => void;
}

interface ClientToServerEvents {
  onJoinFlipFlopRoom: (data: string, callback: (response: { status: string; message: string }) => void) => void;
  onLeaveFlipFlopRoom: (data: string, callback: (response: { status: string; message: string }) => void) => void;
  viewerJoin: (streamingKey: string) => void;
  viewerLeave: (streamingKey: string) => void;
  ownerStreamingJoin: (streamingKey: string) => void;
  ownerStreamingLeave: (streamingKey: string) => void;
}

const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(`${process.env.REACT_APP_SOCKET_IO_HOST}:${process.env.REACT_APP_SOCKET_IO_PORT}`, {
  reconnection: true,
  // reconnectionDelay: 3000,
  // reconnectionDelayMax: 5000,
  query: {
    user_id: `${Service?.userAuth["id"]?.toString()}`,
    token: Service.token,
  },
  extraHeaders: {
    authorization: `Bearer ${Service?.userAuth["authentication_key"]?.toString()}`,
  },
});

socket.on("connect_error", (error) => {
  console.log("Connecting Error", error.message);
});

socket.on("error", (message) => {
  console.log("Socket error:", message);
});

export default socket;
